import { render, staticRenderFns } from "./KennenlernenFooter.vue?vue&type=template&id=2f098552&"
import script from "./KennenlernenFooter.vue?vue&type=script&lang=js&"
export * from "./KennenlernenFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports